/** Format integer cents as a Euro string, e.g. 2500 -> "€25.00". */
export function formatEuros(cents: number): string {
  return `€${(cents / 100).toFixed(2)}`;
}
